module.exports = __webpack_public_path__ + "img/Back_Down.9bf48d60.svg";